<div *ngIf="view$ | async as view">
  <div *ngIf="view.show" [ngClass]="view.messageClasses">
    {{ view.message }}
  </div>
</div>
